import computed from './attrs/computed'
import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import Autocomplete from 'vuejs-auto-complete'
import VueNumericInput from 'vue-numeric-input'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'Purchase',
  computed,
  created,
  data,
  methods,
  mounted,
  watch,
  components: {
    Autocomplete,
    VueNumericInput,
    DateRangePicker
  }
}
